module.exports = __webpack_public_path__ + "static/media/christmas.2037e86e.png";